// extracted by mini-css-extract-plugin
export default {"focusStar":"location_recent-locations_focusStar","disabled":"location_recent-locations_disabled"};